import { PropsWithChildren } from 'react';
import { Center } from '~/commonComponents/Center';

export const Overlay = ({ children }: PropsWithChildren) => (
  <Center
    backgroundColor="rgba(0, 0, 0, 0.5)"
    height="100%"
    inset={0}
    overflow="hidden"
    position="fixed"
    width="100%"
    zIndex={10}
  >
    {children}
  </Center>
);
